const CardType = {
    SET_AVAILABLE_CARD: 'SET_AVAILABLE_CARD',
    SET_REISSUE_MDN: 'SET_REISSUE_MDN'
}
export default CardType;